<div class="create">
    <button class="btn btn-sm btn-primary" (click)="modifyFee()">
        <i class="bi bi-plus"></i>
    </button>
</div>

<form
    [formGroup]="formGroup"
    *ngIf="modTransactionFeeModel"
    (ngSubmit)="saveFee()"
>
    <div class="form-group">
        <div>
            <label>User</label>
            <div>
                <app-component-form-search-user
                    [originalValue]="modTransactionFeeModel.user?.email"
                    (userChanged)="updateSelectedUser($event)"
                ></app-component-form-search-user>
            </div>
        </div>
        <div>
            <label>Rate</label>
            <input
                formControlName="rate"
                type="number"
                class="form-control form-control-sm"
                placeholder="Rate"
                max="1"
            />
        </div>
    </div>

    <div class="mt-1">
        <button [disabled]="formGroup.invalid" class="btn btn-sm btn-primary">
            Save
        </button>
        &nbsp;
        <button
            class="btn btn-sm btn-warning"
            (click)="modTransactionFeeModel = undefined"
        >
            Cancel
        </button>
    </div>
</form>

<table
    mat-table
    #feeTable
    [dataSource]="transactionFeeModels.data"
    class="table-list"
>
    <ng-container matColumnDef="control">
        <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
        <td mat-cell *matCellDef="let transactionFeeModel">
            <div class="btn-group">
                <button
                    class="btn btn-sm btn-success"
                    (click)="modifyFee(transactionFeeModel)"
                >
                    <i class="bi bi-pencil"></i>
                </button>

                <button
                    (click)="confirmDelete(transactionFeeModel)"
                    class="btn btn-sm btn-danger"
                >
                    <i class="bi bi-trash2"></i>
                </button>
            </div>
        </td>
    </ng-container>

    <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>ID</th>
        <td mat-cell *matCellDef="let transactionFeeModel">
            {{ transactionFeeModel.id }}
        </td>
    </ng-container>

    <ng-container matColumnDef="user">
        <th mat-header-cell *matHeaderCellDef>User</th>
        <td mat-cell *matCellDef="let transactionFeeModel">
            {{ transactionFeeModel.user.email }}
        </td>
    </ng-container>

    <ng-container matColumnDef="rate">
        <th mat-header-cell *matHeaderCellDef>Rate</th>
        <td mat-cell *matCellDef="let transactionFeeModel">
            {{ transactionFeeModel.rate }}
        </td>
    </ng-container>

    <ng-container matColumnDef="created_at">
        <th mat-header-cell *matHeaderCellDef>Created At</th>
        <td mat-cell *matCellDef="let transactionFeeModel">
            {{ transactionFeeModel.created_at | date: "longDate" }}
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnHeadings"></tr>
    <tr mat-row *matRowDef="let row; columns: columnHeadings"></tr>
</table>
